export const HeadingThreeBold = ({ children }) => {
    return <h3 className="text-lg sm:text-xl leading-7 font-bold text-gray-800 ">{children}</h3>
  }
  
  export default HeadingThreeBold
  